import useModal from '@javascript/lib/hooks/useModal';
export interface UpgradeBannerProps {
  variant: 'used' | 'electric' | 'bmw-mini' | 'bmw-mini-electric';
}

const UpgradeBanner = ({ variant }: UpgradeBannerProps) => {
  const { ref, openModal, closeModal, maskClickHandlers } = useModal();

  const bannerData = {
    used: {
      theme: 'yellow',
      primaryBoldCopy: <>Two years&#8217; free servicing</>,
      primarySubtleCopy: 'when you buy a used or pre-reg car!',
      showModal: true,
      modalCopy: (
        <>
          Get two years&#8217; free servicing when you buy a used or pre-reg car
          - worth at least £449!
        </>
      ),
      showDivider: true,
    },
    electric: {
      theme: 'yellow',
      primaryBoldCopy: 'Get a home charger from £699',
      primarySubtleCopy: 'when you buy a fully electric used car!',
      showModal: true,
      modalCopy:
        'Get a home charger from £699 when you buy a fully electric used car!',
      showDivider: true,
    },
    'bmw-mini': {
      theme: 'black',
      primaryBoldCopy: false,
      primarySubtleCopy: (
        <>Two years&#8217; free servicing when you buy a used car.</>
      ),
      showModal: true,
      modalCopy: (
        <>Get two years&#8217; free servicing when you buy a used car.</>
      ),
      showDivider: false,
    },
    'bmw-mini-electric': {
      theme: 'black',
      primaryBoldCopy: false,
      primarySubtleCopy:
        'Get a home charger from £699 when you buy a fully electric used car.',
      showModal: true,
      modalCopy:
        'Get a home charger from £699 when you buy a fully electric used car.',
      showDivider: false,
    },
  };

  return (
    <>
      <div
        className={`upgrade-promo upgrade-promo__wrapper upgrade-promo--${bannerData[variant].theme} ch-lh--heading sm:ch-display--flex`}
      >
        <div
          className={`upgrade-promo__primary upgrade-promo__primary--${bannerData[variant].theme}  ch-mb--0 ch-fs--3 md:ch-fs--5 ch-fw--500`}
        >
          <p className="upgrade-promo__primary--text ch-fw--800 ch-mb--0 md:ch-mr--1">
            {bannerData[variant].primaryBoldCopy}
          </p>
          <p className="ch-mb--0 ch-fw--600 ch-fs--3">
            {bannerData[variant].primarySubtleCopy}
          </p>
        </div>
        {bannerData[variant].showModal && (
          <div className="upgrade-promo__secondary">
            <button
              className="upgrade-promo__open-modal ch-flex--none"
              onClick={openModal}
              type="button"
            >
              <span className="ch-reader">info</span>
            </button>
          </div>
        )}
      </div>
      <dialog {...maskClickHandlers} ref={ref}>
        <div
          className={`upgrade-modal upgrade-modal--${bannerData[variant].theme}`}
          data-close-modal
        >
          <div className="ch-modal ch-modal--xs upgrade-modal__content">
            <div className="modal__header upgrade-modal__header ch-bg--ac-yellow">
              <button
                className="ch-modal__close"
                onClick={closeModal}
                type="button"
              >
                <span className="ch-reader">Close</span>
              </button>
            </div>
            {bannerData[variant].showDivider && (
              <div className="upgrade-modal__divider"></div>
            )}
            <div className="ch-text--center ch-pa--4 sl:ch-ph--6">
              <p className="ch-fs--3 ch-text--balance">
                There&#8217;s never been a better time to upgrade your car...
              </p>

              <p className="ch-fs--4 ch-fw--600 ch-lh--heading ch-mb--4 ch-text--balance">
                {bannerData[variant].modalCopy}
              </p>

              <div className="ch-display--grid ch-row-gap--3">
                <div>
                  <a
                    className="ch-btn ch-btn--sm ch-btn--primary"
                    href="/offers"
                  >
                    Find out more
                  </a>
                </div>
                <div>
                  <a
                    className="ch-fs--3 ch-lh--body ch-fw--500"
                    href="/terms#the-upgrade-event"
                  >
                    Terms and conditions apply
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </dialog>
    </>
  );
};

export default UpgradeBanner;
